import { jsxs, jsx } from 'react/jsx-runtime';
import { useContextAccessToken } from '../../../../permission/contexts/AnonShareTokenContext.js';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { nativeWindow } from '@todesktop/client-core';
import { publish } from '@todesktop/client-ipc';
import { useRouter } from '@fabric-app/compat';
import { IconFolder } from '@fabric-app/icons/svg';
import { SystemSubtypes } from '@fabric/woody-client';

const ContextItemOpenEnclosingSpace = () => {
  const router = useRouter();
  const { resource } = useResourceDataContextSafe();
  const accessToken = useContextAccessToken();
  const parentId = resource.parent?.id;
  const isParentFolderSpace = parentId && resource.root?.folder.id === parentId;
  if (accessToken || !parentId || !resource.permission?.canAccessParent) {
    return null;
  }
  const openEnclosingSpace = parentId ? () => {
    let path;
    if (isParentFolderSpace) {
      if (resource.root?.subtype === SystemSubtypes.INBOX) {
        path = "/saved";
      } else {
        path = `/spaces/${parentId}`;
      }
    } else {
      path = `/folders/${parentId}`;
    }
    if (router.pathname === "/desktop-global-search") {
      try {
        publish("open-path", {
          path
        });
      } catch (_e) {
        window.open(`fabric://open-path?path=${path}`, "_blank");
      }
      nativeWindow.close();
      return;
    } else {
      router.push(path, void 0, {
        shallow: true
      });
    }
  } : void 0;
  return parentId && router.pathname !== "/spaces/[listId]" && router.pathname !== "/saved" && router.pathname !== "/folders/[folderId]" && /* @__PURE__ */ jsxs(ContextMenu.Item, {
    onSelect: openEnclosingSpace,
    "data-testid": "item-context-menu-go-to-list-button",
    children: [
      /* @__PURE__ */ jsx(DropdownItemIconContainer, {
        children: /* @__PURE__ */ jsx(IconFolder, {})
      }),
      "Open enclosing ",
      isParentFolderSpace ? "space" : "folder"
    ]
  }) || null;
};

export { ContextItemOpenEnclosingSpace };
//# sourceMappingURL=ContextItemOpenEnclosingSpace.js.map
